// extracted by mini-css-extract-plugin
export default {"divider":"style__divider___VtBA4","link":"style__link___D4Wku"};